import axiosInstance from "./common/axiosInstance";

export interface AddNewLeadPayload {
  service_name: string;
  product_name: string;
  contact_name: string;
  email_id: string;
  country_code: string;
  dial_code: string;
  phone_no: string;
}

export interface AddNewLeadResponse {
  message: string;
  data: number;
  success: boolean;
}

export const addNewLead = async (
  payload: AddNewLeadPayload
): Promise<AddNewLeadResponse> => {
  try {
    console.log("=== ADD NEW LEAD API CALL ===");
    console.log("Endpoint: /lead/addnewlead");
    console.log("Request Payload:", JSON.stringify(payload, null, 2));
    console.log("======================================");

    const response = await axiosInstance.post<AddNewLeadResponse>(
      "/lead/addnewlead",
      payload
    );

    console.log("=== ADD NEW LEAD API RESPONSE ===");
    console.log("Status:", response.status);
    console.log("Response Data:", JSON.stringify(response.data, null, 2));
    console.log("======================================");

    return response.data;
  } catch (error: any) {
    console.log("=== ADD NEW LEAD API ERROR ===");
    console.log("Error Status:", error?.response?.status);
    console.log("Error Response Data:", JSON.stringify(error?.response?.data, null, 2));
    console.log("Error Message:", error?.message);
    console.log("======================================");
    
    // Preserve the error response data structure so message can be extracted properly
    if (error?.response?.data) {
      throw error.response.data;
    }
    throw { message: error?.message || "Failed to save lead. Please try again." };
  }
};

